<div class="container flex-row">
  <div class="parts flex-column">
    <app-header class="header" />
    <app-middle class="middle" />
    <app-bottom class="bottom" />
  </div>
</div>
